<script>
	let name = "WTFSIGFD";
	let themeName = "drink";
	let themeColor = "#FF8400"; //#FF8400
	let appleid = 1194829356;
	let googleid = "sigfd";
	
	import OutboundLink from "svelte-track-outboundlink";

</script>


<style>

	.main {
		display: flex;
		flex-direction: column;
		height: 100%;
		margin:12px;
	}

	@media only screen and (min-width:768px) {
		.main {
			margin: 24px;
		}
	}

	@media only screen and (min-height: 700px) {
		.main {
			justify-content: center;
		}
	}

	p {
		color: #000;
		font-family: "Rajdhani", sans-serif;
		text-transform: uppercase;
		margin-bottom: 0.5em;
		margin-top: 0em;
	}

	.copy {
		font-size: 28px;
		text-align: center;
		margin: 16px 0;
	}



	.copy--footer {
		font-size: 20px;
	}

	.copy--footer p {
		margin-bottom: 1em;
		margin-top: 1em;
	}

	.link :global(a){
		text-decoration: none;
		padding: 0 4px;
		line-height: 0.8;
		color:#4CD0CC;
		border-bottom: 4px solid;

	}

	.link :global(a:hover) {
		color:#4CD0CC;
		/* border-bottom: 4px solid #FF8400; */
	}

	#apple {
		height: 57px;
		display: block;
	}
	#google {
		height: 57px;
		display: block;
	}

	#icon {
		display: block;
		/* border-radius: 24px; */
		margin: 12px auto 48px auto;
		width: 128px;
	}

	ul {
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0;
		padding: 0;
		flex-wrap: wrap;
	}

	li {
		list-style-type: none;
		display: flex;
		align-items: center;
		padding:8px;
	}
</style>

<div class="main">
	<div class="copy">
		<p>“where the fuck should i go to drink?”</p>
		<p>That’s it.</p>
		<p>That’s the fucking app.</p>
	</div>
	
	<img src="assets/icon.png" alt="{name} app icon" id="icon" />
	
	<div class="copy">
		<p>Find places near you where you can fucking drink.</p>
	</div>

	<div class="links">
	<ul>
		<li>
			<OutboundLink href="https://apps.apple.com/us/app/id{appleid}"
			title="Download {name} on the App Store"><img
			src="assets/app-store-badge.svg"
			alt="Download {name} on the app store"
			id="apple" /></OutboundLink>
		</li>
		<li>
			<OutboundLink href="https://play.google.com/store/apps/details?id=studio.omakase.wtf.{googleid}"
				title="Get {name} on Google Play"  
				  >
				<img
					src="assets/google-play-badge.png"
					alt="Download {name} on the app store"
					id="google" />
				</OutboundLink>
		</li>
	</ul>
</div>
	<div class="copy copy--footer">
		<p>The **** Recommendation app.</p>
		<p class="link"> <OutboundLink href="https://wtfsigte.com" title="WHERE THE FUCK SHOULD I GO TO EAT?"  >FUCKING HUNGRY INSTEAD?</OutboundLink>
	</div>
</div>
